import * as React from "react";
import type { DeploymentSettingsPageProps } from "./SharedDeploymentSettingsPage";
import SharedDeploymentSettingsPage from "./SharedDeploymentSettingsPage";
export function BranchDeploymentSettingsPage({ loaderData, gitRef }: DeploymentSettingsPageProps) {
    return <SharedDeploymentSettingsPage loaderData={loaderData} gitRef={gitRef}/>;
}
